import React from 'react'
import PropTypes from 'prop-types'
import { Circle } from 'rc-progress'
import getClassStyle from '../../../utils/getClassStyle'

class ProgressiveLoaderBase extends React.PureComponent {
  constructor(props) {
    super(props)

    const { variation } = props
    this.state = {
      color: getColorFromVariation(variation),
      trailColor: getTrailColorFromVariation(variation),
    }
  }

  componentDidUpdate(prevProps) {
    const { variation } = this.props

    if (prevProps.variation !== variation) {
      this.setState({
        color: getColorFromVariation(variation),
        trailColor: getTrailColorFromVariation(variation),
      })
    }
  }

  render() {
    const { progress, textClasses } = this.props
    const progressPercent = Math.floor(100 * progress)
    const { color, trailColor } = this.state

    return (
      <div className="flex-none relative w-100 h-100">
        <div className="absolute absolute--fill flex items-center justify-center">
          <div className={`flex-none ${textClasses}`}>
            {progressPercent}
            {'%'}
          </div>
        </div>
        <Circle
          percent={progressPercent}
          strokeWidth="5"
          trailWidth="5"
          strokeColor={color}
          trailColor={trailColor}
          strokeLinecap="round"
        />
      </div>
    )
  }
}

const getTrailColorFromVariation = (variation) => {
  const getClass = (variation) => {
    switch (variation) {
      case 'base':
        return 'bg-base'
      default:
        return 'bg-muted-4'
    }
  }

  return getClassStyle(getClass(variation), 'background-color')
}

const getColorFromVariation = (variation) => {
  const getClass = (variation) => {
    switch (variation) {
      case 'base':
        return 'c-on-base'
      case 'primary':
        return 'c-action-primary'
      case 'danger':
        return 'c-danger'
      case 'success':
        return 'c-success'
      case 'warning':
        return 'c-warning'
      default:
        return 'c-on-base'
    }
  }

  return getClassStyle(getClass(variation), 'color')
}

ProgressiveLoaderBase.propTypes = {
  progress: PropTypes.number.isRequired,
  variation: PropTypes.oneOf([
    'base',
    'primary',
    'danger',
    'success',
    'warning',
  ]),
  textClasses: PropTypes.string,
}

ProgressiveLoaderBase.defaultProps = {
  variation: 'base',
  textClasses: '',
}

export default ProgressiveLoaderBase
